import { api } from "api";
import Swal from "sweetalert2";
import moment from "moment/moment";
import { CLIENTE } from "./ventas";
import { handleActions } from "redux-actions";
import { ToastStore } from "react-toasts";
import { TIPO_REPORTE_COMISION } from "../../../utility/variables";

const endpoint = "ventas";

export const DATA = "COMISIONES_DATA";
export const SET_DETALLE = "COMISIONES_SET_DETALLE";
export const DATA_RESUMEN = "COMISIONES_DATA_RESUMEN";
export const LOADER = "COMISIONES_LOADER";
export const SORT = "COMISIONES_SORT";
export const SET_CLIENTE = "COMISIONES_SET_CLIENTE";
export const SET_TIPO = "COMISIONES_SET_TIPO";
export const PAGE = "COMISIONES_PAGE";
export const FILTRO = "REPORTE_GASTOS_FILTRO";
export const FECHA_INICIAL = "COMISIONES_FECHA_INICIAL";
export const FECHA_FINAL = "COMISIONES_FECHA_FINAL";
export const ESTADO_DESCARGA = "COMISIONES_ESTADO_DESCARGA";
export const TOTAL_COMISIONES = "COMISIONES_TOTAL_COMISIONES";
export const SUCURSAL = "COMISIONES_SUCURSAL";

export const TIPO_VENDEDOR = "COMISIONES_TIPO_VENDEDOR";
export const VENDEDOR = "COMISIONESDOR";

// ------------------------------------
// Actions
// ------------------------------------
export const listarReporte =
    (page = 1) =>
    (dispatch, getStore) => {
        dispatch(setLoader(true));
        const store = getStore();
        const {
            ordering,
            filtro,
            fecha_vencimiento_inicial,
            fecha_vencimiento_final,
            sucursal,

            vendedor,
        } = store.reporte_comision_mensual;

        let params = {
            ordering,
            filtro,
            page,
            fecha_inicial: fecha_vencimiento_inicial,
            fecha_final: fecha_vencimiento_final,

            param_sucursal: sucursal,

            vendedor,
        };

        api.get(`${endpoint}/reporte_comision_mensual`, params)
            .catch((err) => {
                Swal("ERROR", "Ha ocurrido un error.", "error");
            })
            .then((resp) => {
                if (resp) {
                    if (resp.extra_data)
                        dispatch(
                            setTotalComisiones({
                                total_venta_sin_iva:
                                    resp.extra_data.total_cobro_sin_iva,
                                total_devolucion_descuento:
                                    resp.extra_data
                                        .total_descuentos_devoluciones,
                                total_neto:
                                    resp.extra_data.total_ventas_vendedor,
                                total_comision:
                                    resp.extra_data.total_comisiones,
                            })
                        );

                    dispatch(setData(resp));
                    dispatch(setPage(page));
                }
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

export const setCliente = (value) => (dispatch) => {
    dispatch(_setCliente(value));
    // dispatch(listarReporte());
};

export const setTipoVendedor = (value) => (dispatch) => {
    dispatch(_setTipoVendedor(value));
    // dispatch(listarReporte());
};

export const setVendedor = (value) => (dispatch) => {
    dispatch(_setVendedor(value));
    // dispatch(listarReporte());
};

export const aplicarFiltros = () => (dispatch, getStore) => {
    const store = getStore();

    const { vendedor, sucursal } = store.reporte_comision_mensual;

    if (vendedor && sucursal) {
        dispatch(listarReporte());
    } else {
        ToastStore.error("Debe seleccionar un vendedor y una sucursal");
    }
};

export const sortChange = (sortName, sortOrder) => (dispatch, getStore) => {
    if (sortOrder === "asc") {
        dispatch(setSort(sortName));
    } else {
        dispatch(setSort(`-${sortName}`));
    }
    const store = getStore();
    const page = store.reporte_ventas.page;
    dispatch(listarReporte(page));
};

export const setFecha = (key, value) => (dispatch, getStore) => {
    const store = getStore();
    const reporte_comision_mensual = store.reporte_comision_mensual;
    if (key === "Inicial") {
        dispatch(setFechaInicial(value));
    } else {
        const fecha_vencimiento_inicial = new Date(
            reporte_comision_mensual.fecha_vencimiento_inicial
        );
        const fecha_vencimiento_final = new Date(value);
        if (fecha_vencimiento_final >= fecha_vencimiento_inicial)
            dispatch(setFechaFinal(value));
    }
};

export const descargarListado = () => (dispatch, getStore) => {
    const store = getStore();
    const cliente = store.reporte_comision_mensual.cliente;
    const {
        ordering,
        filtro,
        fecha_vencimiento_inicial,
        fecha_vencimiento_final,
        sucursal,

        vendedor,
    } = store.reporte_comision_mensual;

    let params = {
        ordering,
        filtro,
        fecha_inicial: fecha_vencimiento_inicial,
        fecha_final: fecha_vencimiento_final,
        param_sucursal: sucursal,

        vendedor,
    };

    dispatch(setEstadoDescarga(true));
    api.get(`${endpoint}/descargar_excel_reporte_comision_mensual`, params)
        .catch((err) => {
            Swal(
                "¡Error al descargar!",
                "Ocurrió un error al descargar el archivo. Por favor intenté más tarde.",
                "error"
            );
            dispatch(setEstadoDescarga(false));
        })
        .then((data) => {
            if (data) {
                Swal(
                    "¡Descarga en proceso!",
                    "La descarga comenzará en un momento. Por favor no recargue la página hasta que se haya descargado el archivo",
                    "info"
                );
                dispatch(setEstadoDescarga(true));
                dispatch(esperarDescarga(data.id));
            }
        });
};

const esperarDescarga = (id) => (dispatch) => {
    let intervalPromise;

    //  VOLVER A HACER LA PETICIÓN PARA VERIFICAR QUE YA TERMINO LA DESCARGA

    function listener() {
        api.get("archivos/estado_descarga", { id })
            .catch((err) => {
                let msg =
                    "Ocurrió un error al descargar el archivo. Por favor intenta más tarde";
                if (err.estado) {
                    msg = err.observaciones;
                }
                dispatch(setEstadoDescarga(false));
                clearInterval(intervalPromise);
                Swal("Error al descargar!", msg, "error");
            })
            .then((resp) => {
                if (resp.estado === 10) {
                    // PROCESANDO
                    dispatch(setEstadoDescarga(true));
                } else if (resp.estado === 20) {
                    // TERMINADO
                    clearInterval(intervalPromise);
                    let nombre = resp.archivo
                        ? resp.archivo.split("/media/archivos/")[1]
                        : "Bajas_salidas_por_producto.xlsx";
                    const context = {
                        name: name,
                        url: resp.archivo,
                    };

                    dispatch(setEstadoDescarga(false));
                    dispatch(descargaArchivo(context));
                }
            });
    }

    listener();
    intervalPromise = setInterval(listener, 1000);
};

const descargaArchivo = (context) => (dispatch) => {
    let elem = document.createElement("a");
    elem.href = context.url;
    elem.download = context.name;
    elem.target = "hiddenIframe";
    elem.click();
    dispatch(setEstadoDescarga(false));
    ToastStore.success("Archivo descargado exitosamente");
};

export const setDataValue = (data) => (dispatch) => {
    dispatch(setData(data));
};

export const setSucursal = (value) => (dispatch) => {
    dispatch(_setSucursal(value));
};

// ------------------------------------
// PureActions
// ------------------------------------
export const setData = (data) => ({
    type: DATA,
    data,
});

export const setDataResumen = (data_resumen) => ({
    type: DATA_RESUMEN,
    data_resumen,
});

export const setLoader = (loader) => ({
    type: LOADER,
    loader,
});

export const _setCliente = (cliente) => ({
    type: CLIENTE,
    cliente,
});

export const setSort = (ordering) => ({
    type: SORT,
    ordering,
});

export const setPage = (page) => ({
    type: PAGE,
    page,
});

export const setDetalle = (detalle) => ({
    type: SET_DETALLE,
    detalle,
});

export const setFiltro = (filtro) => ({
    type: FILTRO,
    filtro,
});

export const setFechaInicial = (fecha_vencimiento_inicial) => ({
    type: FECHA_INICIAL,
    fecha_vencimiento_inicial,
});

export const setFechaFinal = (fecha_vencimiento_final) => ({
    type: FECHA_FINAL,
    fecha_vencimiento_final,
});

const setEstadoDescarga = (estado_descarga) => ({
    type: ESTADO_DESCARGA,
    estado_descarga,
});

export const _setTipoVendedor = (tipo_vendedor) => ({
    type: TIPO_VENDEDOR,
    tipo_vendedor,
});

export const _setVendedor = (vendedor) => ({
    type: VENDEDOR,
    vendedor,
});

export const _setSucursal = (sucursal) => ({
    type: SUCURSAL,
    sucursal,
});

export const setTotalComisiones = (total_comisiones) => ({
    type: TOTAL_COMISIONES,
    total_comisiones,
});

export const actions = {
    listarReporte,
    setDataValue,
    setCliente,
    sortChange,
    setFecha,

    setTipoVendedor,
    setVendedor,
    setSucursal,
    aplicarFiltros,

    descargarListado,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [DATA_RESUMEN]: (state, { data_resumen }) => {
        return {
            ...state,
            data_resumen,
        };
    },
    [SET_DETALLE]: (state, { detalle }) => {
        return {
            ...state,
            detalle,
        };
    },
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [CLIENTE]: (state, { cliente }) => {
        return {
            ...state,
            cliente,
        };
    },
    [SORT]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [FILTRO]: (state, { filtro }) => {
        return {
            ...state,
            filtro,
        };
    },
    [FECHA_INICIAL]: (state, { fecha_vencimiento_inicial }) => {
        return {
            ...state,
            fecha_vencimiento_inicial,
        };
    },
    [FECHA_FINAL]: (state, { fecha_vencimiento_final }) => {
        return {
            ...state,
            fecha_vencimiento_final,
        };
    },
    [ESTADO_DESCARGA]: (state, { estado_descarga }) => {
        return {
            ...state,
            estado_descarga,
        };
    },

    [TIPO_VENDEDOR]: (state, { tipo_vendedor }) => {
        return {
            ...state,
            tipo_vendedor,
        };
    },
    [VENDEDOR]: (state, { vendedor }) => {
        return {
            ...state,
            vendedor,
        };
    },
    [TOTAL_COMISIONES]: (state, { total_comisiones }) => {
        return {
            ...state,
            total_comisiones,
        };
    },
    [SUCURSAL]: (state, { sucursal }) => {
        return {
            ...state,
            sucursal,
        };
    },
};

// ------------------------------------
// InitialState
// ------------------------------------

export const initialState = {
    data: {},
    page: 1,
    data_resumen: {},
    detalle: {},
    cliente: null,
    ordering: "",
    loader: false,
    filtro: "",
    fecha_vencimiento_inicial: moment().format("YYYY-MM-DD"),
    fecha_vencimiento_final: moment().format("YYYY-MM-DD"),
    estado_descarga: false,

    tipo_vendedor: "",
    vendedor: "",
    sucursal: "",
    total_comisiones: {
        total_venta_sin_iva: 0,
        total_devolucion_descuento: 0,
        total_neto: 0,
        total_comision: 0,
    },
};

export default handleActions(reducers, initialState);
